export default __webpack_public_path__ + "static/media/avatar_2_1.c36ad7fc.png";